angular.module('task-project')
    .factory('TaskProjectGroup', function ($resource) {
        return $resource('/crm/api/task-group-project/:id', {id: "@id"}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/task-group-project/table'},
            remove: {method: 'DELETE'},
            get: {method: 'GET'},
            update: {method: 'PUT'}
        });
    })
    .service('TaskProjectGroupService', function (TaskProjectGroup, modals, $rootScope) {
        this.add = () => {
            return modals.open('app/task/task-project-group/edit-modal.html', 'TaskProjectGroupEditController', {}, {size: "md"}, "$ctrl").then(() => $rootScope.$broadcast('task-project-group.updated'))
        }
        this.show = (id) => {
            return modals.open('app/task/task-project-group/show-modal.html', 'TaskProjectGroupShowController', {id: id}, {size: "md"}, "$ctrl")
        }
        this.edit = (id) => {
            return modals.open('app/task/task-project-group/edit-modal.html', 'TaskProjectGroupEditController', {id: id}, {size: "md"}, "$ctrl").then(() => $rootScope.$broadcast('task-project-group.updated'))
        }
        this.delete = (project) => {
            const text = `
                <div style="margin-bottom: 1rem;">Czy na pewno chcesz usunąć grupę projektów <b>${project.name}</b>?</div>
                <div>
                    <div class="well well-sm" style="margin-bottom: 1rem;">
                        <span class="bold text-center text-danger"><i class="fa fa-fw fa-exclamation-triangle"></i>&nbsp;UWAGA!&nbsp;</span>
                        Wszystkie projekty przypisane do tej grupy pozostaną zapisane w systemie, ale nie będą przypisane do żadnej grupy projektów.
                    </div>
                </div>
            `
            return modals.confirm(text, () => TaskProjectGroup.delete({id: project.id}).$promise.then(() => $rootScope.$broadcast('task-project-group.deleted')));
        }
    })
    .controller("TaskProjectGroupEditController", function ($scope, $uibModalInstance, TaskProjectGroup, data) {
        this.$onInit = () => {
            if(data.id != null)
                TaskProjectGroup.get({id: data.id}).$promise.then(item => this.item = item)
            else
                this.item = {}
        }
        this.save = () => {
            let $promise
            if (this.item.id != null) {
                $promise = TaskProjectGroup.update(this.item).$promise
            } else {
                $promise = TaskProjectGroup.save(this.item).$promise
            }
            return $promise.then(() => $uibModalInstance.close())
        }
        this.toggleExtend = () => {
            this.item.action = "EXTEND"
        }
        this.toggleRestrict = () => {
            this.item.action = "RESTRICT"
        }
        this.cancel = () => $uibModalInstance.dismiss()
    })
    .controller('TaskProjectGroupShowController', function ($scope, $uibModalInstance, TaskProjectGroup, data) {
        this.$onInit = () => {
            TaskProjectGroup.get({id: data.id}).$promise.then(item => this.item = item)
        }
        this.cancel = () => $uibModalInstance.dismiss()
        $scope.$on('task-project-group.updated', () => this.$onInit());
        $scope.$on('task-project-group.deleted', () => this.cancel());
    })
